import { GET_USER_ACTIVITY_HISTORIES } from '../graphql/queries/users'
import { USER_ACTIVITY_TARGET_TYPE } from '../utils/const'

export async function getPlaylistDetailActivities(apolloClient, { schoolId, targetId, page, limit }) {
  const { data } = await apolloClient.query({
    query: GET_USER_ACTIVITY_HISTORIES,
    variables: {
      targetType: USER_ACTIVITY_TARGET_TYPE.PLAYLIST,
      schoolId,
      targetId,
      page,
      limit,
    },
    fetchPolicy: 'no-cache',
  })
  return data
}
